import styled from 'styled-components';
import { PaginationJumpItemMixin } from '../../mixins/components/PaginationJumpItemMixin';

/**
 * Used by the `Pagination` component to house the "previous" and "next" buttons based on
 * `PaginationButton`.
 *
 * @since 7.42.0
 */
var PaginationJumpItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "PaginationJumpItem",
  componentId: "c11n-8-111-1__sc-h97wcm-0"
})(["", ""], PaginationJumpItemMixin);
PaginationJumpItem.displayName = 'PaginationJumpItem';

/** @component */
export { PaginationJumpItem };